import { render, staticRenderFns } from "./micoapp_audit.vue?vue&type=template&id=56f671d2&scoped=true"
import script from "./micoapp_audit.vue?vue&type=script&lang=js"
export * from "./micoapp_audit.vue?vue&type=script&lang=js"
import style0 from "./micoapp_audit.vue?vue&type=style&index=0&id=56f671d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f671d2",
  null
  
)

export default component.exports